<template>
    <Default v-if="!loading"></Default>
    <div v-else class="loading-screen" :class="className">
        <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
    </div>
</template>
<script>
import Default from '../layouts/Default.vue'
export default {
    components: {
        Default
    },
    computed: {
        loading() {            
            return this.$store.state.loading
        }
    },
}
</script>